import LicenseLimitedModal, {
  LicenseLimitedModalPropsBase,
} from "@/components/modal/license-limited-modals/license-limited-modal";
import React from "react";
import { textToMusicLicenseManager } from "@/services/license/license-managers/text-to-music-license-manager";

const TextToMusicCountLimitedModal = ({
  licenseName,
}: LicenseLimitedModalPropsBase) => {
  const count =
    textToMusicLicenseManager.serviceUsingCountLimiter.getPlanLimit(
      licenseName,
    );

  return (
    <LicenseLimitedModal
      licenseName={licenseName}
      upgradeToMessage={"generate unlimited number of AI text to music songs"}
      allowsMessage={`${licenseName} version allows you to generate only ${count} text to music${count > 1 ? "'s" : ""} per day.`}
      shouldNavigateToPricing={true}
    />
  );
};

export default TextToMusicCountLimitedModal;
